// import TestimonialMap from './images/testimonialmap.png';

const TestimonialMap =
  'https://movingworldspublic.blob.core.windows.net/public/landing/testimonialmap.webp';

const TestimonialMapSection = () => {
  return (
    <div className='hidden sm:block'>
      <img className='w-full h-fit aspect-auto' src={TestimonialMap} />
    </div>
  );
};

export default TestimonialMapSection;
